var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "client-results-page"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                Filtrování\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 text-center"
  }, [(_vm.doctors.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignedTo),
      expression: "assignedTo"
    }],
    staticClass: "mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "client-results-doctor-filter"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assignedTo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("všichni doktoři")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.selectedStates.indexOf('accepted') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "accepted",
      "data-testid": "client-results-filter-accepted"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('accepted')
      }
    }
  }, [_vm._v("nepřiřazené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "accepted",
      "data-testid": "client-results-filter-accepted"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('accepted'), 1)
      }
    }
  }, [_vm._v("nepřiřazené")]), _vm._v(" "), (_vm.selectedStates.indexOf('assigned') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "assigned",
      "data-testid": "client-results-filter-assigned"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('assigned')
      }
    }
  }, [_vm._v("nevyhodnocené")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "assigned",
      "data-testid": "client-results-filter-assigned"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('assigned'), 1)
      }
    }
  }, [_vm._v("nevyhodnocené")]), _vm._v(" "), (_vm.selectedStates.indexOf('wait_for_doctor') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "wait_for_doctor",
      "data-testid": "client-results-filter-wait-for-doctor"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('wait_for_doctor')
      }
    }
  }, [_vm._v("předáno na doktora")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "wait_for_doctor",
      "data-testid": "client-results-filter-wait-for-doctor"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('wait_for_doctor'), 1)
      }
    }
  }, [_vm._v("předáno na doktora")]), _vm._v(" "), (_vm.selectedStates.indexOf('completed') < 0) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    attrs: {
      "value": "canceled",
      "data-testid": "client-results-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.push('completed')
      }
    }
  }, [_vm._v("dokončeno")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "value": "canceled",
      "data-testid": "client-results-filter-completed"
    },
    on: {
      "click": function($event) {
        _vm.selectedStates.splice(_vm.selectedStates.indexOf('completed'), 1)
      }
    }
  }, [_vm._v("dokončeno")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "data-testid": "client-results-refresh"
    },
    on: {
      "click": function($event) {
        _vm.getDoctorsDayTasks()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), (_vm.listData.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.listData), function(task, index) {
    return [_c('tr', {
      staticClass: "row m-0",
      class: _vm.openedTaskId === task.id ? 'border border-primary border-bottom-0' : '',
      attrs: {
        "data-testid": 'client-results-row-' + task.id
      }
    }, [_c('td', {
      staticClass: "align-middle col-sm-1"
    }, [(_vm.openedTaskId === task.id) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'client-results-toggle-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(task.id, task)
        }
      }
    }, [_vm._v("-")]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": 'client-results-toggle-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.openTaskId(task.id, task)
        }
      }
    }, [_vm._v("+")])]), _vm._v(" "), _c('td', {
      staticClass: "align-middle col-sm-2",
      attrs: {
        "data-testid": 'client-results-state-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("taskStateToCS")(task.state)) + "\n\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'client-results-client-' + task.id
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'client-results-doctor-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(task.assigned_to ? task.assigned_to.fullname : '') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3",
      attrs: {
        "data-testid": 'client-results-received-' + task.id
      }
    }, [_vm._v("\n                        " + _vm._s(task.received_on) + "\n                    ")])]), _vm._v(" "), (_vm.openedTaskId === task.id) ? _c('tr', {
      staticClass: "row m-0 border border-primary border-top-0 border-bottom-0",
      attrs: {
        "data-testid": 'client-results-client-info-' + task.id
      }
    }, [_c('td', {
      staticClass: "col-md-12"
    }, [_vm._v("\n                        " + _vm._s(task.client_info_line) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.openedTaskId === task.id) ? _c('tr', {
      staticClass: "row m-0 border border-primary border-top-0",
      attrs: {
        "data-testid": 'client-results-detail-' + task.id
      }
    }, [_c('td', {
      staticClass: "col-md-6"
    }, [_c('b', {
      staticClass: "p-4"
    }, [_vm._v("Laboratorní výsledek")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "target": "_blank",
        "role": "button",
        "href": _vm.hostname.hostname + 'result/' + task.id + '/pdf',
        "data-testid": 'client-results-print-' + task.id
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    }), _vm._v(" Tisknout")]), _vm._v(" "), (_vm.sendResultPending === false) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "data-testid": 'client-results-resend-' + task.id
      },
      on: {
        "click": function($event) {
          _vm.putResult(task.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-mail-forward",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")]) : _c('button', {
      staticClass: "btn btn-sm btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Odeslat e-mailem")]), _vm._v(" "), _c('div', {
      staticClass: "p-4",
      staticStyle: {
        "white-space": "pre-wrap",
        "font-family": "monospace, monospace",
        "font-size": "medium"
      },
      attrs: {
        "id": "result_text",
        "data-testid": 'client-results-content-' + task.id
      },
      domProps: {
        "innerHTML": _vm._s(task.result)
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-md-6"
    }, [(task.state === 'completed') ? [_vm._v("\n                            Zpráva odeslaná klientovi:"), _c('br'), _c('br'), _vm._v(" "), _c('p', {
      attrs: {
        "data-testid": 'client-results-evaluation-' + task.id
      }
    }, [_c('b', [_vm._v("\n                                    " + _vm._s(task.evaluation) + "\n                                ")])])] : _vm._e()], 2)]) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('pagination-component', {
    attrs: {
      "list-pagination": _vm.listPagination
    },
    on: {
      "set-page": _vm.setPage
    }
  })], 1) : (_vm.listPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "client-results-empty"
    }
  }, [_vm._m(2)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Stav")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Klient")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Doktor")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("Datum přijetí")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-frown-o fa-3x"
  }), _c('br'), _vm._v("\n            (nebyl nalezen žádný výsledek dle požadavků)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2c73acc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientResult.vue
// module id = 636
// module chunks = 0